// Shared category palette + display order for the editor dashboard.
//
// Mirrors the Newsletter v2 preview (public/HXD-newsletter-preview.html) so the
// editor surfaces (Pipeline Debrief category spread chart, Editor.jsx category
// sections, sidebar ProgressPanel) all read with the same color language that
// subscribers see in the published email.

export const CATEGORY_ORDER = [
  'Unmanned',
  'Airspace',
  'Manned',
  'AI',
  'Manufacturing',
];

export const CATEGORY_PALETTE = {
  Unmanned: { bar: '#F08F36', track: '#FFF6E8', ink: '#8A2412', pill: '#C44D2F' },
  Airspace: { bar: '#38BDF8', track: '#EFF6FF', ink: '#075985', pill: '#0E7AB5' },
  Manned: { bar: '#4ADE80', track: '#F0FDF4', ink: '#166534', pill: '#228B4A' },
  AI: { bar: '#A78BFA', track: '#F5F3FF', ink: '#5B21B6', pill: '#7C4AD4' },
  Manufacturing: { bar: '#FCD34D', track: '#FFFBEB', ink: '#854D0E', pill: '#B8730C' },
};

export const CATEGORY_FALLBACK = {
  bar: '#888888',
  track: '#F5F5F5',
  ink: '#333333',
  pill: '#525252',
};

export function categoryRank(category) {
  const idx = CATEGORY_ORDER.indexOf(category);
  return idx === -1 ? CATEGORY_ORDER.length : idx;
}

export function paletteFor(category) {
  return CATEGORY_PALETTE[category] || CATEGORY_FALLBACK;
}

/** Lighter fill for category pills on marketing cards (Latest posts, welcome). */
export function categoryPillStyle(category) {
  const palette = paletteFor(category);
  const bg = palette.pill || palette.bar;
  return {
    backgroundColor: bg,
    border: `1px solid ${bg}`,
  };
}
